import {createSelector} from 'reselect';
import {getSettings} from '../../selectors';

const getIsAmazonPayScriptSrcSet = createSelector(
  [getSettings],
  settings => !!settings && settings.amazonpay_script_source,
);

export default getIsAmazonPayScriptSrcSet;
